<template>
<div>
  <service-object-alarm :serviceObj="serviceObj" @handleAlarm="getPersonNew"></service-object-alarm>
  <div style="height: 1px;background-color: #ebebeb;"></div>
  <div style="margin-top: 20px;text-align: right;margin-right: 20px">
    <el-row>
      <el-col :span="2">
        <span style="color: red">*</span><span>服务地址：</span>
      </el-col>
      <el-col :span="22">
        <el-input style="color: #1a1a1a" type="textarea" :rows="2" placeholder="请输入地址" v-model="sendServiceObj.address"></el-input>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="2" style="line-height: 40px"><span style="color: red">*</span><span>上门时间：</span></el-col>
      <el-col :span="6">
        <el-date-picker v-fixZoom :picker-options="pickerOptions" style="width: 100%" v-model="sendServiceObj.service_appointment_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" default-time="10:00:00"></el-date-picker>
      </el-col>
      <el-col :span="2" style="line-height: 40px"><span style="color: red">*</span><span>服务类型：</span></el-col>
      <el-col :span="7">
        <el-cascader v-fixZoom style="width: 100%" v-model="showid" placeholder="请选择" :options="typeEndTree" :props="propType"
                     filterable change-on-select clearable ref="stidData" @change="getStidImgNew">
          <template #default="{data}">
            <span v-if="data.noSelect" style="font-style: italic;color: #999999">{{ data.showName}}</span><strong v-else style="color: #1a1a1a;">{{ data.showName}}</strong>
          </template>
        </el-cascader>
<!--        <el-cascader v-fixZoom style="width: 100%" v-model="sendServiceObj.service_type" placeholder="请选择" :options="options" :props="props1"-->
<!--                     filterable change-on-select clearable ref="stidData" @change="getTypeSelect"></el-cascader>-->
      </el-col>
      <el-col :span="7" v-if="sendServiceObj.service_type === -1">
        <el-input v-model="sendServiceObj.service_name" placeholder="请输入服务类型"></el-input>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="2" style="line-height: 40px"><span style="color: red">*</span><span>服务设备：</span></el-col>
      <el-col :span="6">
        <el-select v-fixZoom filterable style="width: 100%" v-model="sendServiceObj.did" placeholder="请选择服务设备">
          <el-option v-for="item in homeDeviceTable" :key="item.id" :label="item.deviceid" :value="item.id"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2" style="line-height: 40px"><span>服务内容：</span></el-col>
      <el-col :span="14">
        <el-input v-model="sendServiceObj.service_content" placeholder="请输入服务内容备注"></el-input>
      </el-col>
    </el-row>
  </div>
  <div style="height: 50px;margin-right: 20px;margin-top: 20px;float: right"><div class="send-btn" @click="sendService()"><span>发起服务</span></div></div>
  <div style="clear: both"></div>
</div>
</template>

<script>
import serviceObjectAlarm from '../../handlealarm/childComponents/serviceObjectAlarm'
import {
  querysupplierorgnotype,
  querysupplierservice,
  querysuppliertype
} from '../../../api/serviceMark'
import {querybinddevicebyhome} from '../../../api/serviceObject'
import {createservicerecord} from '../../../api/service'

export default {
  name: 'sendOrder',
  components: {serviceObjectAlarm},
  model: {
    prop: 'orderShow',
    event: 'change'
  },
  props: {
    orderObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      // 派单
      supplierorgNew: [], // 服务商
      serviceData: [], // 服务内容
      orgData: [], // 组织
      showid: '',
      propType: { checkStrictly: true, value: 'showId', label: 'showName', children: 'child', emitPath: false, disabled: 'noSelect' },
      typeEndTree: [],
      allType: [],
      types: [],
      supplierorg: [],
      stid: '',
      soid: '',
      options: [],
      newTypes: [],
      props1: { checkStrictly: true, value: 'id', label: 'showname', children: 'child', emitPath: false },
      // 服务对象
      serviceObj: {
        projects: [],
        frequencys: [],
        oldperson: '',
        editOldPerson: '', // 客服关爱编辑生命体征
        isCallBack: false
      },
      serviceTypes: [],
      sendServiceObj: {
        address: '',
        service_type: '',
        service_name: '',
        service_appointment_time: '',
        service_content: '',
        did: ''
      },
      homeDeviceTable: []
    }
  },
  created () {
    this.serviceObj.oldperson = this.orderObj.oldperson
    this.serviceObj.projects = this.orderObj.projects
    this.serviceObj.frequencys = this.orderObj.frequencys
    this.sendServiceObj.address = this.orderObj.oldperson.h_address
    this.orgData = this.orderObj.orgData
    console.log(this.orderObj.oldperson)
    this.querySupplier()
    this.getDeviceByHids()
  },
  methods: {
    // 查询设备
    getDeviceByHids () {
      this.homeDeviceTable = []
      let data = {
        hids: [this.orderObj.oldperson.homeid]
      }
      querybinddevicebyhome(data).then(res => {
        let arr = res.data.devices
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].devicetype === 700 || arr[i].devicetype === 504 || arr[i].devicetype === 507) {
            this.homeDeviceTable.push(arr[i])
          }
        }
        if (this.homeDeviceTable.length === 0) {
          this.homeDeviceTable.push({id: 0, deviceid: '暂无设备'})
        }
        this.sendServiceObj.did = this.homeDeviceTable[0].id
      }).catch(() => {})
    },
    changeType (id) {
      if (id === 0) {
        this.sendServiceObj.service_name = ''
      } else {
        for (let i = 0; i < this.serviceTypes.length; i++) {
          if (id === this.serviceTypes[i].id) {
            this.sendServiceObj.service_name = this.serviceTypes[i].typename
          }
        }
      }
    },
    // 服务商
    querySupplier () {
      let params = {
        page: 1,
        size: 9999
      }
      querysupplierorgnotype(params).then(res => {
        this.supplierorgNew = res.data.org
        this.querySupplierType()
      }).catch(() => {})
    },
    // 服务类型
    querySupplierType () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: []
      }
      querysuppliertype(params, data).then(res => {
        this.types = res.data.types
        this.getServiceContent()
      }).catch(() => {})
    },
    // 服务内容
    getServiceContent () {
      let params = {
        page: 1,
        size: 99999
      }
      querysupplierservice(params).then(res => {
        this.serviceData = res.data.service
        let obj = this.commonType.getNewPaidan(this.orgData, this.supplierorgNew, this.types, this.serviceData)
        this.typeEndTree = obj.tree
        this.typeEndTree.push({showId: -1, showName: '其他类型', noSelect: false})
        this.allType = obj.allArr
      }).catch(() => {})
    },
    getStidImgNew (id) {
      console.log(id)
      if (id === -1) {
        this.sendServiceObj.service_type = id
        this.sendServiceObj.service_name = ''
      } else {
        let obj = ''
        this.allType.forEach(item => {
          if (item.showId === id) {
            console.log(item)
            obj = item
          }
        })
        for (let i = 0; i < this.types.length; i++) {
          if (obj.st_id === this.types[i].id) {
            this.sendServiceObj.service_name = this.types[i].typename
            this.sendServiceObj.service_type = this.types[i].id
            console.log(this.types[i])
          }
        }
      }
    },
    sendService () {
      //   address: '',
      // service_type: '',
      //   service_name: '',
      //   service_appointment_time: ''
      if (this.sendServiceObj.address === '' || this.sendServiceObj.service_type === '' || this.sendServiceObj.service_name === '' || this.sendServiceObj.service_appointment_time === '') {
        this.$message({
          type: 'warning',
          message: '请完整信息内容',
          duration: 4000
        })
      }
      let sexName = ''
      if (this.orderObj.oldperson.sex === 0) {
        sexName = 'F'
      } else if (this.orderObj.oldperson.sex === 1) {
        sexName = 'M'
      }
      let data = {
        did: this.sendServiceObj.did,
        pid: this.orderObj.oldperson.id,
        service_object: this.orderObj.oldperson.name,
        birth_date: this.orderObj.oldperson.birthday,
        gender: sexName,
        address: this.sendServiceObj.address,
        service_name: this.sendServiceObj.service_name,
        service_type: this.sendServiceObj.service_type === -1 ? '0' : this.sendServiceObj.service_type + '',
        service_content: this.sendServiceObj.service_content,
        service_appointment_time: this.sendServiceObj.service_appointment_time
      }
      createservicerecord(data).then(res => {
        this.$message({
          type: 'success',
          message: '成功发起派单',
          duration: 3000
        })
        this.$emit('change', false)
      }).catch(() => {})
    },
    getPersonNew (person) {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/sendOrder.vue